import { render, staticRenderFns } from "./SecurityTab.vue?vue&type=template&id=07343a45&scoped=true&"
import script from "./SecurityTab.vue?vue&type=script&lang=js&"
export * from "./SecurityTab.vue?vue&type=script&lang=js&"
import style0 from "./SecurityTab.vue?vue&type=style&index=0&id=07343a45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07343a45",
  null
  
)

export default component.exports